import { MonogramBadge } from './monogram-badge.js';

export function LoginBrandPanel() {
  return (
    <div className="relative hidden overflow-hidden bg-primary text-primary-foreground lg:flex lg:flex-col lg:justify-between lg:p-12">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-24 -right-24 size-72 rounded-full bg-primary-foreground/5 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute bottom-12 -left-16 size-56 rounded-full bg-primary-foreground/10 blur-2xl"
      />

      <div className="relative">
        <MonogramBadge className="mb-8 size-14" />
        <h1 className="text-4xl font-bold tracking-tight">Nudool</h1>
        <p className="mt-4 max-w-sm text-base leading-relaxed text-primary-foreground/80">
          ERP and business management built for modern teams.
        </p>
      </div>

      <p className="relative text-sm text-primary-foreground/60">
        &copy; {new Date().getFullYear()} Nudool
      </p>
    </div>
  );
}
